export default "__VITE_PUBLIC_ASSET__2ab0199c__"